import React from "react";
import PermitFormStackedLabel from "./PermitFormStackedLabel";
import PermitFormUnstackedLabel from "./PermitFormUnstackedLabel";

interface IPermitFormCheckboxLabel {
  isFeeExist: boolean;
  staffOnly: boolean;
  customFieldName: string;
  stacked: boolean;
}

const PermitFormCheckboxLabel = ({ isFeeExist, staffOnly, customFieldName, stacked }: IPermitFormCheckboxLabel) => {
  return stacked ? (
    <PermitFormStackedLabel customFieldName={customFieldName} staffOnly={staffOnly} />
  ) : (
    <PermitFormUnstackedLabel isFeeExist={isFeeExist} staffOnly={staffOnly} customFieldName={customFieldName} />
  );
};

export default PermitFormCheckboxLabel;
